import { useMutation } from '@tanstack/react-query';
import { request } from '../services/request';

export const useSearchbyemil = () => {
    return useMutation(async (data: { Query: string; PageNumber: number; PageSize: number }) => {
        const jsonResponse = await request({
            data,
            method: 'POST', 
            endpoint: 'contacts/searchContacts', 
        });

        if (!jsonResponse.success) {
            throw new Error(jsonResponse.data.Message || 'Something went wrong');
        }

        return jsonResponse;
    });
};
